module.exports = __webpack_public_path__ + "media/images/audio-waves-min-1999fe0580f1cc91f08f5a9d76a7317c7cd5bcc0b67093d07ab8c5da3bebf483.svg";